export const labelsUI = {
  welcome: document.querySelector<HTMLParagraphElement>(".welcome")!,
  date: document.querySelector<HTMLParagraphElement>(".date")!,
  balance: document.querySelector<HTMLParagraphElement>(".balance__value")!,
  sumIn: document.querySelector<HTMLParagraphElement>(".summary__value--in")!,
  sumOut: document.querySelector<HTMLParagraphElement>(".summary__value--out")!,
  sumInterest: document.querySelector<HTMLParagraphElement>(
    ".summary__value--interest",
  )!,
  timer: document.querySelector<HTMLSpanElement>(".timer")!,
};

export const containersUI = {
  app: document.querySelector<HTMLElement>(".app")!,
  movements: document.querySelector<HTMLDivElement>(".movements")!,
  modal: document.querySelector<HTMLDivElement>(".modal"),
  overlay: document.querySelector<HTMLDivElement>(".overlay"),
};

export const buttonsUI = {
  login: document.querySelector<HTMLButtonElement>(".login__btn")!,
  transfer: document.querySelector<HTMLButtonElement>(".form__btn--transfer")!,
  loan: document.querySelector<HTMLButtonElement>(".form__btn--loan")!,
  close: document.querySelector<HTMLButtonElement>(".form__btn--close")!,
  sort: document.querySelector<HTMLButtonElement>(".btn--sort")!,
  signupOpenForm:
    document.querySelector<HTMLButtonElement>(".signup__openForm"),
  signupSubmitForm: document.querySelector<HTMLButtonElement>(
    ".signup__submitForm",
  ),
};

export const inputsUI = {
  loginUsername: document.querySelector<HTMLInputElement>(
    ".login__input--user",
  )!,
  loginPin: document.querySelector<HTMLInputElement>(".login__input--pin")!,
  transferTo: document.querySelector<HTMLInputElement>(".form__input--to")!,
  transferAmount: document.querySelector<HTMLInputElement>(
    ".form__input--amount",
  )!,
  loanAmount: document.querySelector<HTMLInputElement>(
    ".form__input--loan-amount",
  )!,
  closeUsername:
    document.querySelector<HTMLInputElement>(".form__input--user")!,
  closePin: document.querySelector<HTMLInputElement>(".form__input--pin")!,
  signupFirstInput: document.querySelector<HTMLInputElement>(
    ".signup__firstInput",
  ),
  signupUsername: document.querySelector<HTMLInputElement>("#username"),
  signupPin: document.querySelector<HTMLInputElement>("#pin"),
  signupConfirmPin: document.querySelector<HTMLInputElement>("#confirmPin"),
};

export const userSelect = document.getElementById("user-select")!;
